import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/pages/auth/Login.vue'
import Logout from '@/pages/auth/Logout.vue'
import Auth from '@/pages/auth/Auth.vue'
import Home from '@/pages/Home.vue'
import KinmuList from '@/pages/kinmu/List.vue'
import HakenKinmuList from '@/pages/kinmu/HakenList.vue'
import ShinseiTypeList from '@/pages/shinsei/TypeList.vue';
import ShinseiMenu from '@/pages/shinsei/Menu.vue';
import ShinseiEdit from '@/pages/shinsei/Form.vue'
import ShinseiNoApproval from '@/pages/shinsei/NoApproval.vue'
import ShinseiDetail from '@/pages/shinsei/Detail.vue'
import ShinseiDetailNoApproval from '@/pages/shinsei/DetailNoApproval.vue'
import ShinseiList from '@/pages/shinsei/List.vue'
import ZangyouList from '@/pages/shinsei/ZangyouList.vue';
import PxKintaiCsv from '@/pages/px/kintaicsv/Form.vue';
import NotFoundError from '@/pages/errors/404.vue'
import KoyouKeiyakuMenu from '@/pages/koyoukeiyaku/Menu.vue'
import KoyouKeiyakuSearch from '@/pages/koyoukeiyaku/Search.vue'
import KoyouKeiyakuSDetail from '@/pages/koyoukeiyaku/Detail.vue'
import KoyouKeiyakuEdit from '@/pages/koyoukeiyaku/Edit.vue'
import KoyouKeiyakuModify from '@/pages/koyoukeiyaku/Modify.vue'
import KoyouKeiyakuPdfDisp from '@/pages/koyoukeiyaku/PdfDisp.vue'
import MeijisyoDetail from '@/pages/meijisyo/Detail.vue'
import SyuugyouKisokuList from '@/pages/syuugyoukisoku/List.vue';
import SyuugyouKisokuDetail from '@/pages/syuugyoukisoku/Detail.vue';
import YuukyuuKanriList from '@/pages/yuukyuukanri/List.vue';
import YuukyuuKanriDetail from '@/pages/yuukyuukanri/Detail.vue';
import YuukyuuKanriCreate from '@/pages/yuukyuukanri/Create.vue';
import SyainiList from '@/pages/syain/List.vue';
import SyainDetail from '@/pages/syain/Detail.vue';
import SyainUpdate from '@/pages/syain/Update.vue';
import SyainFileDisp from '@/pages/syain/FileDisp.vue';
import GroupMember from '@/pages/syain/GroupMember.vue'
import ForgotPassword from '@/pages/auth/ForgotPassword.vue';
import ResetPassword from '@/pages/auth/ResetPassword.vue';
import MasterMaintenanceList from '@/pages/master/List.vue';
import MstSyouninGroupCreate from '@/pages/master/syounin_group/Create.vue';
import MstSyouninGroupSearch from '@/pages/master/syounin_group/Search.vue';
import MstSyouninGroupEdit from '@/pages/master/syounin_group/Edit.vue';
import MstBukaSearch from '@/pages/master/buka/BukaSearch.vue';
import MstBukaEdit from '@/pages/master/buka/BukaEdit.vue';
import PermissionRolesSetting from '@/pages/admin/PermissionRolesSetting.vue';
import RenrakuMenu from '@/pages/renraku/MenuList.vue';
import RenrakuCreate from '@/pages/renraku/create/Form.vue';
import RenrakuDetail from '@/pages/renraku/detail/Form.vue';
import RenrakuSearch from '@/pages/renraku/search/Form.vue';
import MyTask from '@/pages/mytask/Form.vue';
import OshiraseList from '@/pages/oshirase/List.vue';
import FurideCsv from '@/pages/furidecsv/Form.vue';
import { useAuthStore } from '@/store/auth'
import { RouterConst } from '@/const/Router'
import { DialogService } from '@/service/DialogService'
import { PermissionConst } from '@/const/Permission'
import Message from '@/const/Message'
import { useKoyouKeiyakuSearchStore } from './store/koyoukeiyaku-search'
import TokenLogin from '@/pages/auth/TokenLogin.vue';
import { useSignalStore } from './store/signal'
import Config from './const/Config'
import { APP_MODE } from './const/Constants'
import { useConfigStore } from './store/config'
import { OperationSupportLog } from './types/OperationSupport'
import { useOperationSupportLog } from './composable/operation_support/log'

const routes = [
  {
    path: '/' + RouterConst.LOGIN,
    component: Login,
    name: RouterConst.LOGIN,
    meta: { isPublish: true },
  },
  {
    path: '/' + RouterConst.LOGOUT,
    component: Logout,
    name: RouterConst.LOGOUT,
    meta: { isPublish: true },
  },
  {
    path: '/' + RouterConst.AUTH,
    component: Auth,
    name: RouterConst.AUTH,
    meta: { isPublish: true },
  },
  {
    path: '/token_login',
    component: TokenLogin,
    name: RouterConst.TOKEN_LOGIN,
    meta: { isPublish: true },
  },
  {
    path: '/forgot_password',
    component: ForgotPassword,
    name: RouterConst.ForgotPassword,
    meta: { isPublish: true },
  },
  {
    path: '/reset_password/:token',
    component: ResetPassword,
    name: RouterConst.ResetPassword,
    meta: { isPublish: true },
  },
  {
    path: '/' + RouterConst.HOME,
    component: Home,
    name: RouterConst.HOME,
  },
  {
    path: '/' + RouterConst.JINJI,
    name: RouterConst.JINJI,
    children: [
      {
        path: 'px/kintai_csv',
        component: PxKintaiCsv,
        name: RouterConst.PX_KINTAI_CSV
      },
      {
        path: RouterConst.KOYOUKEIYAKU,
        name: RouterConst.KOYOUKEIYAKU,
        children: [
          {
            path: 'menu',
            component: KoyouKeiyakuMenu,
            name: RouterConst.KOYOUKEIYAKU_MENU
          },
          {
            path: 'edit',
            component: KoyouKeiyakuEdit,
            name: RouterConst.KOYOUKEIYAKU_EDIT
          },
          {
            path: 'modify/:id',
            component: KoyouKeiyakuModify,
            name: RouterConst.KOYOUKEIYAKU_MODIFY
          },
          {
            path: 'search',
            component: KoyouKeiyakuSearch,
            name: RouterConst.KOYOUKEIYAKU_SEARCH
          },
          {
            path: 'detail/:id',
            component: KoyouKeiyakuSDetail,
            name: RouterConst.KOYOUKEIYAKU_DETAIL,
          },
          {
            path: 'detail/:id/meijisyo',
            component: MeijisyoDetail,
            name: RouterConst.MEIJISYO_DETAIL,
          },
          {
            path: 'pdfdisp/:id',
            component: KoyouKeiyakuPdfDisp,
            name: RouterConst.KOYOUKEIYAKU_PDF_DISP
          },
        ]
      },
      {
        path: RouterConst.YUUKYUU_KANRI,
        name: RouterConst.YUUKYUU_KANRI,
        children: [
          {
            path: 'list',
            component: YuukyuuKanriList,
            name: RouterConst.YUUKYUU_KANRI_LIST
          },
          {
            path: 'detail/:code',
            component: YuukyuuKanriDetail,
            name: RouterConst.YUUKYUU_KANRI_DETAIL
          },
          {
            path: 'create/:id',
            component: YuukyuuKanriCreate,
            name: RouterConst.YUUKYUU_KANRI_CREATE,
          },
        ]
      },
      {
        path: RouterConst.SYAIN,
        name: RouterConst.SYAIN,
        children: [
          {
            path: 'create',
            component: SyainUpdate,
            name: RouterConst.SYAIN_CREATE,
          },
          {
            path: 'list',
            component: SyainiList,
            name: RouterConst.SYAIN_LIST
          },
          {
            path: 'detail/:id',
            component: SyainDetail,
            name: RouterConst.SYAIN_DETAIL
          },
          {
            path: 'edit/:id',
            component: SyainUpdate,
            name: RouterConst.SYAIN_EDIT,
          },
          {
            path: 'fileDisp/:name',
            component: SyainFileDisp,
            name: RouterConst.SYAIN_FILE_DISP
          },
        ]
      },
      {
        path: RouterConst.MASTER,
        name: RouterConst.MASTER,
        children: [
          {
            path: 'menu',
            component: MasterMaintenanceList,
            name: RouterConst.MST_MENU,
          },
          {
            path: 'syounin_group',
            name: 'syounin_group',
            children: [
              {
                path: 'create',
                component: MstSyouninGroupCreate,
                name: RouterConst.MST_SYOUNIN_GROUP_CREATE,
              },
              {
                path: 'search',
                component: MstSyouninGroupSearch,
                name: RouterConst.MST_SYOUNIN_GROUP_SEARCH,
              },
              {
                path: 'edit/:id',
                component: MstSyouninGroupEdit,
                name: RouterConst.MST_SYOUNIN_GROUP_EDIT,
              }]
          },
          {
            path: 'buka',
            name: 'buka',
            children: [
              {
                path: 'search',
                component: MstBukaSearch,
                name: RouterConst.MST_BUKA_SEARCH,
              },
              {
                path: 'edit/:bukaId?',
                component: MstBukaEdit,
                name: RouterConst.MST_BUKA_EDIT,
              }
            ]
          }
        ]
      },
      {
        path: RouterConst.ADMIN,
        name: RouterConst.ADMIN,
        children: [
          {
            path: RouterConst.PERMISSION_ROLES_SETTING,
            component: PermissionRolesSetting,
            name: RouterConst.PERMISSION_ROLES_SETTING,
          },
        ]
      },
    ]
  },
  {
    path: '/' + RouterConst.KINTAI,
    name: RouterConst.KINTAI,
    children: [
      {
        path: 'group_member',
        component: GroupMember,
        name: RouterConst.GROUP_MEMBER
      },
      {
        path: RouterConst.KINMU,
        name: RouterConst.KINMU,
        children: [
          {
            path: 'list/:syuugyouBasyoId?',
            component: KinmuList,
            name: RouterConst.KINMU_LIST
          },
          {
            path: 'list/haken/:kintaiSummaryId?',
            component: HakenKinmuList,
            name: RouterConst.HAKEN_KINMU_LIST
          },
        ]
      },
      {
        path: RouterConst.SHINSEI,
        name: RouterConst.SHINSEI,
        children: [
          {
            path: 'menu',
            component: ShinseiMenu,
            name: RouterConst.SHINSEI_MENU,
          },
          {
            path: 'type_list',
            component: ShinseiTypeList,
            name: RouterConst.SHINSEI_TYPE_LIST
          },
          {
            path: 'list',
            component: ShinseiList,
            name: RouterConst.SHINSEI_LIST
          },
          {
            path: ':type',
            component: ShinseiNoApproval,
            name: RouterConst.SHINSEI_NO_APPROVAL
          },
          {
            path: 'create/:type',
            component: ShinseiEdit,
            name: RouterConst.SHINSEI_CREATE
          },
          {
            path: 'again/:type/:id',
            component: ShinseiEdit,
            name: RouterConst.SHINSEI_AGAIN
          },
          {
            path: 'edit/:type/:id',
            component: ShinseiEdit,
            name: RouterConst.SHINSEI_EDIT
          },
          {
            path: 'detail/:id',
            component: ShinseiDetail,
            name: RouterConst.SHINSEI_DETAIL
          },
          {
            path: 'detail_no_approval/:type/:id',
            component: ShinseiDetailNoApproval,
            name: RouterConst.SHINSEI_DETAIL_NO_APPROVAL
          },
          {
            path: 'zangyou_list/',
            component: ZangyouList,
            name: RouterConst.ZANGYOU_LIST
          },
        ]
      },
      {
        path: 'syuugyou_kisoku',
        name: RouterConst.SYUUGYOU_KISOKU,
        children: [
          {
            path: 'list/',
            component: SyuugyouKisokuList,
            name: RouterConst.SYUUGYOU_KISOKU_LIST,
          },
          {
            path: 'detail/:id',
            component: SyuugyouKisokuDetail,
            name: RouterConst.SYUUGYOU_KISOKU_DETAIL
          }
        ]
      },
      {
        path: RouterConst.RENRAKU,
        name: RouterConst.RENRAKU,
        children: [
          {
            path: RouterConst.RENRAKU_MENU,
            component: RenrakuMenu,
            name: RouterConst.RENRAKU_MENU,
          },
          {
            path: RouterConst.RENRAKU_CREATE,
            component: RenrakuCreate,
            name: RouterConst.RENRAKU_CREATE,
          },
          {
            path: RouterConst.RENRAKU_DETAIL + '/:type?' + '/:oshiraseId?',
            component: RenrakuDetail,
            name: RouterConst.RENRAKU_DETAIL,
          },
          {
            path: RouterConst.RENRAKU_SEARCH,
            component: RenrakuSearch,
            name: RouterConst.RENRAKU_SEARCH,
          },
        ]
      },
      {
        path: RouterConst.MY_TASK + '/:from?',
        component: MyTask,
        name: RouterConst.MY_TASK,
      },
      {
        path: RouterConst.OSHIRASE_LIST,
        component: OshiraseList,
        name: RouterConst.OSHIRASE_LIST,
      },
      {
        path: RouterConst.FURIDE_CSV_DOWNLOAD,
        component: FurideCsv,
        name: RouterConst.FURIDE_CSV_DOWNLOAD,
      },
    ]
  }
];

const router = createRouter({
  routes,
  history: createWebHistory('/app'),
})

router.beforeEach(async (to, from, next) => {
  const koyouKeiyakuSearchStore = useKoyouKeiyakuSearchStore();
  const authStore = useAuthStore()

  const signalStore = useSignalStore()
  signalStore.abort();

  const { saveLog } = useOperationSupportLog()

  if (to.matched.find(matched => matched.name === RouterConst.LOGOUT)) {
    next()
    return // ここでreturnするのでこの後になにか処理をする場合は要注意
  }

  // 雇用契約機能を利用する場合の初期化(TODO: もっと後ろのほうが適切かも)
  if (from.matched.find(matched => matched.name === RouterConst.KOYOUKEIYAKU)) {
    if (!to.matched.find(matched => matched.name === RouterConst.KOYOUKEIYAKU)) {
      await koyouKeiyakuSearchStore.init()
    }
  }

  // システム設定ストアの初期化
  if (authStore.isAuth) {
    try {
      const log = new OperationSupportLog()
      await log.setLogInfo('クライアントサイドのRouter', 'システム設定ストア初期化（デバッグ環境のみ）', 'アクセス先：' + to.name?.toString())
      await saveLog(log)
    } catch (e) {
      // ログの記録失敗時に処理続行するよう握りつぶす
    }
    const configStore = useConfigStore()
    await configStore.init()
  }

  // 認証済みチェック
  if (!to.matched.some(record => record.meta.isPublish) && !authStore.isAuth) {

    try {
      const log = new OperationSupportLog()
      await log.setLogInfo('クライアントサイドのRouter', '認証チェック：否認', 'アクセス先：' + to.name?.toString())
      await saveLog(log)
    } catch (e) {
      // ログの記録失敗時に処理続行するよう握りつぶす
    }
    next({ name: RouterConst.AUTH, query: { redirect: to.fullPath } })
    return // ここでreturnするのでこの後になにか処理をする場合は要注意
  }

  // アプリで人事システムへアクセスしようとした場合は弾く
  // ただし「アプリで」という判定にQRログインで使用する画面のnameで判定しているので厳密ではない
  // ブラウザ普通にログインしようとするとアクセスできるが最終的にIP制限をかけるのでこの程度に留めている
  if (
    Config.APP_MODE == APP_MODE.JINJI
    && to.matched.find(matched => matched.name === RouterConst.TOKEN_LOGIN)
  ) {
    await DialogService.error({
      title: '',
      text: 'アプリでの人事システムの利用は情報セキュリティの観点から許可されていません。人事システム用ユーザーにてPC版をご利用ください。'
    })

    next({ name: RouterConst.LOGOUT })

    return // ここでreturnするのでこの後になにか処理をする場合は要注意
  }

  // 認証関係のページ以外のページに、人事システムへのアクセス権が無いユーザーがアクセスしようとした場合に弾く
  // ここではディレクトリ単位ではなくenvのAPP_MODEを基準に判定
  if (
    to.matched.find(matched => matched.name !== RouterConst.AUTH)
    && to.matched.find(matched => matched.name !== RouterConst.ResetPassword)
    && to.matched.find(matched => matched.name !== RouterConst.ForgotPassword)
    && to.matched.find(matched => matched.name !== RouterConst.LOGIN)
    && Config.APP_MODE == APP_MODE.JINJI
    && !authStore.hasPermission(PermissionConst.CAN_ACCESS_JINJI
    )
  ) {
    await DialogService.error({
      title: '',
      text: 'このアカウントでは人事システムへのアクセスが許可されていません'
    })

    next({ name: RouterConst.LOGOUT })

    return // ここでreturnするのでこの後になにか処理をする場合は要注意
  }

  // 認証関係のページ以外のページに、勤怠システムへのアクセス権が無いユーザーがアクセスしようとした場合に弾く
  // ここではディレクトリ単位ではなくenvのAPP_MODEを基準に判定
  if (
    to.matched.find(matched => matched.name !== RouterConst.TOKEN_LOGIN)
    && to.matched.find(matched => matched.name !== RouterConst.AUTH)
    && to.matched.find(matched => matched.name !== RouterConst.ResetPassword)
    && to.matched.find(matched => matched.name !== RouterConst.ForgotPassword)
    && to.matched.find(matched => matched.name !== RouterConst.LOGIN)
    && Config.APP_MODE == APP_MODE.KINTAI
    && !authStore.hasPermission(PermissionConst.CAN_ACCESS_KINTAI)
  ) {
    await DialogService.error({
      title: '',
      text: 'このアカウントでは勤怠システムへのアクセスが許可されていません'
    })

    next({ name: RouterConst.LOGOUT })

    return // ここでreturnするのでこの後になにか処理をする場合は要注意
  }

  // 遷移可能か
  let canNext = true;

  let dialogTitle = Message.ERROR_PERMISSION.DIALOG_TITLE
  let dialogText = Message.ERROR_PERMISSION.TEXT

  // console.log('APP_MODE', Config.APP_MODE)
  // console.log('勤怠システムへのアクセス権', authStore.hasPermission(PermissionConst.CAN_ACCESS_KINTAI))
  // console.log('人事システムへのアクセス権', authStore.hasPermission(PermissionConst.CAN_ACCESS_JINJI))

  // 人事ディレクトリへのチェック
  // ここではユーザーの権限とenvのAPP_MODEの一致は確認済みの前提で判定
  if (to.matched.find(matched => matched.name === RouterConst.JINJI)) {
    if (
      Config.APP_MODE == APP_MODE.JINJI
      && authStore.hasPermission(PermissionConst.CAN_ACCESS_JINJI)
    ) {
      // 人事用ディレクトリへのアクセス権限をチェック
      let permission = ''
      if (to.matched.find(matched => matched.name === RouterConst.SYAIN)) {
        canNext = authStore.hasPermission(PermissionConst.SYAIN_MASTER)
        permission = PermissionConst.SYAIN_MASTER
      } else if (to.matched.find(matched => matched.name === RouterConst.KOYOUKEIYAKU)) {
        canNext = authStore.hasPermission(PermissionConst.KOYOUKEIYAKU)
        permission = PermissionConst.KOYOUKEIYAKU
      } else if (to.matched.find(matched => matched.name === RouterConst.PX_KINTAI_CSV)) {
        canNext = authStore.hasPermission(PermissionConst.PX)
        permission = PermissionConst.PX
      } else if (to.matched.find(matched => matched.name === RouterConst.RENRAKU)) {
        canNext = authStore.hasPermission(PermissionConst.RENRAKU)
        permission = PermissionConst.RENRAKU
      } else if (to.matched.find(matched => matched.name === RouterConst.ADMIN)) {
        canNext = authStore.hasPermission(PermissionConst.SYSTEM_ADMIN)
        permission = PermissionConst.SYSTEM_ADMIN
      }

      if (!canNext) {
        dialogTitle = 'アクセス権限がありません'
        dialogText = 'ロール『' + authStore.role?.role_name + '』に対して権限『' + permission + '』が付与されていないためアクセスできません'
      }
    } else {
      // 人事システム以外から人事用ディレクトリにアクセスしようとした場合に弾く
      canNext = false;
      dialogTitle = 'アクセスできない領域です'
      dialogText = '人事システムの機能を使用したい場合は人事システムサーバーにてログインし直してください'
    }
  } else {
    // 勤怠／人事共通の機能に対するアクセス権限のチェック
    let permission = ''
    if (to.matched.find(matched => matched.name === RouterConst.SHINSEI_TYPE_LIST)) {
      // 申請作成（種別一覧）
      // ※直接URLを叩けば作成画面自体にアクセスはできるが、アクセスできないユーザーは承認グループの設定がされていなかったり、
      //  最終的にはAPIで弾くので緩めの指定にしている（不都合があればifの条件を強化）
      canNext = authStore.hasPermission(PermissionConst.SHINSEI_CREATE)
      permission = PermissionConst.SHINSEI_CREATE
    } else if (to.matched.find(matched => matched.name === RouterConst.SYUUGYOU_KISOKU)) {
      // 就業規則の閲覧
      canNext = authStore.hasPermission(PermissionConst.SYUUGYOU_KISOKU_VIEW_ALL)
      permission = PermissionConst.SYUUGYOU_KISOKU_VIEW_ALL
    } else if (to.matched.find(matched => matched.name === RouterConst.RENRAKU)) {
      // 会社連絡の閲覧
      canNext = authStore.hasPermission(PermissionConst.RENRAKU_SEARCH_VIEW)
      permission = PermissionConst.RENRAKU_SEARCH_VIEW
    }

    if (!canNext) {
      dialogTitle = 'アクセス権限がありません'
      dialogText = 'ロール『' + authStore.role?.role_name + '』に対して権限『' + permission + '』が付与されていないためアクセスできません'
    }

  }

  // 管理者アカウントの場合は上記の結果関係なくtrue
  if (authStore.isAdmin) {
    canNext = true
  }

  // 遷移可否判定
  if (!canNext) {
    // 遷移不可の場合は権限エラーメッセージを表示
    await DialogService.error({
      title: dialogTitle,
      text: dialogText
    })

    if (from.name === RouterConst.AUTH) {
      // 認証情報取得ページの場合はホーム画面へ遷移
      router.push({
        name: RouterConst.HOME
      })
      return // ここでreturnするのでこの後になにか処理をする場合は要注意
    } else {
      // それ以外は遷移を中止
      next(false)
      return // ここでreturnするのでこの後になにか処理をする場合は要注意
    }
  }

  next()
});

export default router
